module.exports = __webpack_public_path__ + "img/loding2.356e69bd.gif";